<div [dir]="this.app.getUserDire()">
    <div *ngIf="pageMode == 1">
        <p class="boostP mb-4">{{ 'social.boostPost' | translate }}</p>

        <p class="budgetDur mb-2">{{ 'social.budgetDur' | translate }}</p>

        <p class="resBudg mb-5">
            <span *ngIf="priceRes">{{priceRes}} {{ 'SearchDoctor.JD' | translate }} {{ 'social.over' | translate }}
                {{get("Days")?.value}} {{ 'social.days' | translate }}</span>
        </p>

        <div [formGroup]="form" class="row">

            <div class="col-6">
                <div class="d-flex justify-content-start mb-3">
                    <p class="budgetDur">{{ 'social.Duration' | translate }}</p>
                    <p *ngIf="get('Days')?.value" class="valueBudg"> : {{get("Days")?.value}} {{ 'social.days'
                        | translate }}</p>
                </div>

                <!-- <mat-radio-group formControlName="typeH" (change)="radioBtns($event.value)">
                    <mat-radio-button color="primary" class="d-block" [value]="1">Run This Ad Until I Pause
                        It</mat-radio-button>
                    <mat-radio-button color="primary" class="d-block" [value]="2">Set Duration</mat-radio-button>
                </mat-radio-group> -->

                <!-- [disabled]="get('typeH')?.value != 2" -->
                <mat-slider class="w-100 mt-3" [max]="boostInfo?.maxBoostDays" (change)="onToggle($event.value)"
                    [min]="boostInfo?.minBoostDays" [step]="1" [thumbLabel]="true" formControlName="Days"
                    color="primary">
                </mat-slider>


            </div>

            <div class="col-6">
                <p class="budgetDur mb-3">{{ 'social.Budget' | translate }}</p>

                <!-- Years Of Experience -->
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label> {{ 'SearchDoctor.JD' | translate }} </mat-label>
                    <input [disabled]="true" autocomplete="off" type="number" [value]="priceRes" matInput>
                </mat-form-field>

            </div>

        </div>

        <div class="d-flex justify-content-end mt-4">

            <button [disabled]="!get('Days').value" (click)="next1()" class="btn btnNext px-5">
                {{ 'medicalHis.next' | translate }}
            </button>

        </div>
    </div>

    <div *ngIf="pageMode == 2">

        <p class="boostP mb-4">{{ 'social.reviewYour' | translate }}</p>

        <div class="mb-4 d-flex">

            <div *ngIf="insights?.postMedia && insights?.postMedia[0]?.mediaType == 1" class="d-inline-block">
                <img class="border-less" [src]="app.getUserImage(insights?.postMedia[0]?.mediaFilePath)"
                    alt="User Image">
            </div>

            <div class="mx-2 pt-2 w-100">
                <div>
                    <p class="yourReportP">{{insights?.postText}}</p>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-6 mb-4">
                <p class="subMainP">{{ 'social.adGoal' | translate }}</p>
                <p class="subMainV">{{boostInfo?.adGoals}}</p>
            </div>
            <div class="col-6 mb-4">
                <p class="subMainP">{{ 'social.audience' | translate }}</p>
                <p class="subMainV">{{boostInfo?.audience}}</p>
            </div>
            <div class="col-6 mb-4">
                <p class="subMainP">{{ 'social.budgetDur' | translate }}</p>

                <p class="subMainV">
                    <!-- <span *ngIf="get('typeH').value == 1">{{boostInfo?.dailyPrice}} {{ 'SearchDoctor.JD' | translate }}
                        {{ 'social.daily' | translate }} / {{ 'social.runsTill' | translate }}</span> -->

                    <!-- *ngIf="get('typeH').value == 2" -->
                    <span>{{priceRes}} {{ 'SearchDoctor.JD' | translate }} {{
                        'social.over' | translate }}
                        {{get("Days")?.value}} {{ 'social.days' | translate }}</span>
                </p>

            </div>
            <div class="col-6 mb-4">
                <div class="d-flex justify-content-between">
                    <p class="subMainP">{{ 'social.payment' | translate }}</p>
                    <div *ngIf="letRefresh" class="dotRefresh" (click)="getMyCards()">
                        <mat-icon class="text-white">refresh</mat-icon>
                    </div>
                </div>

                <!-- <p *ngIf="usedCards == null" class="addBtV pointer" (click)="addPayment()">
                    {{ 'social.add' | translate }}
                </p> -->

                <div class="w-100" *ngIf="usedCards">

                    <!-- usedCards-->
                    <mat-form-field [dir]="this.app.getUserDire()" class="col-12 px-2" appearance="outline"
                        fxFlex="auto">
                        <mat-label>{{ 'social.cards' | translate }}</mat-label>
                        <mat-select autocomplete="off" [formControl]="paymentCardSelected">
                            <mat-option *ngFor="let card of usedCards" [value]="card.id">
                                <div class="d-flex">
                                    <div class="d-inline-block">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <i *ngIf="card?.type == 'VISA'" class="fa fa-cc-visa  cardI"></i>
                                                <i *ngIf="card?.type == 'MASTER'" class="fa fa-cc-mastercard cardI"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-inline-block">
                                        <div class="d-flex">
                                            <div class="d-flex align-items-center">
                                                <div>
                                                    <p class="m-0">*****{{card?.last4Digits}} {{ 'social.expiryIn' |
                                                        translate }} : {{card?.expiryMonth}}/{{card?.expiryYear}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-option>

                            <mat-option>
                                <p class="addBtV pointer m-0" (click)="addPayment()">
                                    {{ 'social.add' | translate }}
                                </p>
                            </mat-option>


                        </mat-select>
                    </mat-form-field>

                </div>

            </div>
        </div>



        <div class="d-flex justify-content-between mt-4">
            <p class="w-50 youWontP">
                {{ 'social.youWont' | translate }}
            </p>

            <button [disabled]="!paymentCardSelected.value" (click)="next2()" class="btn btnNext px-5">
                {{ 'social.boostPost' | translate }}
            </button>

        </div>
    </div>

    <div *ngIf="pageMode == 3">

        <p class="boostP mb-4">{{ 'social.nonDis' | translate }}</p>

        <div class="row">
            <div class="col-6 mb-4">
                <p class="subMainP">{{ 'social.aboutOurNon' | translate }}</p>
                <p class="subMainV">{{boostInfo?.nonDiscriminationPolicy}}</p>
            </div>

        </div>



        <div class="d-flex justify-content-end mt-4">

            <button [disabled]="!paymentCardSelected?.value || form?.invalid" (click)="next3()" class="btn btnNext px-5">
                {{ 'social.accept' | translate }}
            </button>

        </div>
    </div>
</div>